import type { Cart } from "@packages/sdk";

type GetCartIsPaymentRequiredProps = {
  cart: Cart;
};

export const getCartIsPaymentRequired = ({
  cart,
}: GetCartIsPaymentRequiredProps) => (cart ? cart.payment_required : true);
